import { v4 as uuidv4 } from 'uuid';
import { AnalyticsContext, ExperimentSource } from '../../types';
import { setCookie, getCookie } from '../../utils/cookies';
import { makePostRequest } from '../../utils/requests';

const UUID_COOKIE_NAME = 'whoop-experiment-uuid';

export default {
  getVariant: async (name: string, filters?: AnalyticsContext) => {
    const cookieValue = getCookie<string>(UUID_COOKIE_NAME);
    const uuid = cookieValue || uuidv4();

    const headers = {
      'Content-Type': 'application/json',
      'X-WHOOP-Installation-Identifier': uuid,
    };
    const body = filters ? JSON.stringify(filters) : undefined;
    const variant = await makePostRequest<string>(
      `experiment-service/v1/experiments/name/${name}/variant`,
      headers,
      body
    );

    setCookie<string>(UUID_COOKIE_NAME, uuid);

    return variant;
  },
} as ExperimentSource;
